import {
  EPOCUS_AMBER,
  EPOCUS_GREEN,
  EPOCUS_RED,
  EPOCUS_TEXT_SECONDARY,
} from "./epocus-palette";

// Semantic QA score thresholds — shared by me/page and program/page
export const SCORE_GOOD = EPOCUS_GREEN;
export const SCORE_OK = EPOCUS_AMBER;
export const SCORE_LOW = EPOCUS_RED;

export const getScoreColor = (score: string): string => {
  if (score === "—") return EPOCUS_TEXT_SECONDARY;
  const n = parseFloat(score);
  if (n >= 4.0) return SCORE_GOOD;
  if (n >= 3.5) return SCORE_OK;
  return SCORE_LOW;
};
